import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';

const CONFIDENCE_OPTIONS = ['low', 'medium', 'high'];

const EditPickDialog = ({ open, pick, onClose, onSave }) => {
  const [analysis, setAnalysis] = useState('');
  const [odds, setOdds] = useState('');
  const [confidence, setConfidence] = useState('medium');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (pick) {
      setAnalysis(pick.analysis || '');
      setOdds(pick.odds != null ? String(pick.odds) : '');
      setConfidence(pick.confidence || 'medium');
    }
  }, [pick]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const updates = {
        analysis: analysis.trim(),
        odds: odds !== '' ? parseFloat(odds) : null,
        confidence,
      };
      await onSave(pick.id, updates);
    } catch (err) {
      console.error('Edit save failed', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Pick</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Analysis"
          multiline
          rows={5}
          value={analysis}
          onChange={(e) => setAnalysis(e.target.value)}
          sx={{ mt: 1 }}
        />

        <TextField
          fullWidth
          label="Odds"
          value={odds}
          onChange={(e) => setOdds(e.target.value)}
          sx={{ mt: 2 }}
        />

        <TextField
          select
          fullWidth
          label="Confidence"
          value={confidence}
          onChange={(e) => setConfidence(e.target.value)}
          sx={{ mt: 2 }}
        >
          {CONFIDENCE_OPTIONS.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPickDialog;
